"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFilterOperationTranslationKey = exports.getEnumValueTranslationKey = void 0;
const string_1 = require("./string");
const getEnumValueTranslationKey = (enumName, value) => `filters.multiselect.${enumName}.${value.toLowerCase()}`;
exports.getEnumValueTranslationKey = getEnumValueTranslationKey;
// TODO: replace operation by FilterOperation type when GraphQL Enum problem is solved
const getFilterOperationTranslationKey = (type, operation) => `filters.operations.${(0, string_1.pascalCaseToCamelCase)(type)}.${(0, string_1.pascalCaseToCamelCase)(operation)}`;
exports.getFilterOperationTranslationKey = getFilterOperationTranslationKey;
